// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fcku","colMin":"styles_colMin__3-rpE"};